// src/utils/search.js
// TEK KAYNAK (G8): Türkçe-duyarlı arama altyapısı.
// Tüm TextField aramaları ve Autocomplete filtreleri buradan beslenir (Faz 6'da bağlanır).

/**
 * Türkçe-duyarlı normalizasyon:
 * 1) toLocaleLowerCase('tr-TR')  → 'I' → 'ı', 'İ' → 'i' (İngilizce toLowerCase'in
 *    'İ' → 'i̇' (i + birleşik nokta) tuzağına düşmez)
 * 2) aksan katlama                → ş→s, ç→c, ö→o, ü→u, ğ→g, ı→i
 * Sonuç: "IŞIK" ve "ışık" aynı anahtara ("isik") iner — iki yönlü eşleşme garantisi.
 * null/undefined güvenli: her zaman string döner.
 */
export const normalizeTr = (metin) => {
    if (metin === null || metin === undefined) return '';
    return String(metin)
        .toLocaleLowerCase('tr-TR')
        .replace(/ş/g, 's')
        .replace(/ç/g, 'c')
        .replace(/ö/g, 'o')
        .replace(/ü/g, 'u')
        .replace(/ğ/g, 'g')
        .replace(/ı/g, 'i')
        // olası ayrık birleşik işaretler (ör. NFD kaynaklı) temizlenir
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
};

/**
 * Çok alanlı arama havuzu üretir: verilen alanların hepsini normalize edip
 * tek metinde birleştirir. null/undefined alanlar sessizce atlanır.
 * Kullanım: aramaMetniUret(m.adSoyad, m.telefon, m.plaka).includes(normalizeTr(q))
 */
export const aramaMetniUret = (...alanlar) =>
    alanlar.map(normalizeTr).filter(Boolean).join(' ');

/**
 * MUI Autocomplete için ortak filterOptions (createFilterOptions muadili).
 * MUI'nin createFilterOptions'ı girilen metni İngilizce toLowerCase ile küçültür;
 * 'İ' → 'i̇' (birleşik noktalı) ürettiğinden Türkçe'de eşleşme kaçırır — bu yüzden
 * iki tarafı da normalizeTr'den geçiren kendi filtremiz kullanılır.
 * Sözleşme createFilterOptions ile aynı: (options, { inputValue, getOptionLabel }).
 */
export const trFilterOptions = (options, { inputValue, getOptionLabel }) => {
    const sorgu = normalizeTr(inputValue).trim();
    if (!sorgu) return options;
    return options.filter((secenek) =>
        normalizeTr(getOptionLabel(secenek)).includes(sorgu)
    );
};
